import { combineReducers } from 'redux';
import { appReducer } from './app/reducer';
import { uiReducer } from './ui/reducer';
import { authentication } from './auth/reducer';
import { msalReducer } from './msal/reducer';
import { conversationReducer } from './conversation/reducer';
import { modalWindowReducer } from './modalWindow/reducer';
import { nextcloudReducer } from './nextcloud/reducer';
import { defaultFolderReducer } from './defaultFolder/reducer';

const rootReducer = combineReducers({
    modalWindowReducer,
    appReducer,
    uiReducer,
    authentication,
    msal: msalReducer,
    conversation: conversationReducer,
    nextcloud: nextcloudReducer,
    defaultFolder: defaultFolderReducer,
});

export default rootReducer;
